// extracted by mini-css-extract-plugin
export var statItem = "_mj-1";
export var statsRow = "_mj-0";